import { combineReducers } from 'redux'
import { teammates } from './users'
import { smallView, currentView } from './people'

export default combineReducers({
    smallView,
    teammates,
    currentView
})
